import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';

import './Olimpiade.css';

export default function Olimpiade() {
    return (
        <Container className="olimpiadeContainer worldwide">
            <p className="olimpiadeTitle">
                <span className="bracket">{'<'}</span>
                    Olimpiade
                <span className="bracket">{'/>'}</span>
            </p>
            <p className="olimpiadeSubTitle">Află mai multe despre Olimpiade</p>
            <Row>
                <p className="olimpiadeDescription">
                    Olimpiadele naționale din România reprezintă cele mai înalte forme de competiție educațională pentru elevii
                    pasionați de diferite domenii științifice și tehnologice. Printre cele mai importante olimpiade din sfera
                    informaticii și tehnologiei se numără ONI, ONTI, OIA și OSC, fiecare cu specificul și provocările sale.
                </p>
                <p className="olimpiadeText1">ONI - Olimpiada Națională de Informatică - <a href="/olimpiade/Regulament_ONI_2025.pdf" className="fixColor" target="blank">Regulament</a> | <a href="/olimpiade/Programă Olimpiada de Informatică.pdf" className="fixColor" target="blank">Programă</a></p>
                <p className="olimpiadeText2">
                    ONI este dedicată elevilor pasionați de programare și algoritmică. Competiția se desfășoară în mai multe
                    etape - locală, județeană și națională - și reunește cei mai buni tineri programatori din țară. Subiectele
                    constau în probleme de algoritmică ce trebuie rezolvate pe calculator, fiind evaluate automat. Cei mai buni
                    participanți ajung să reprezinte România la olimpiade internaționale precum IOI sau CEOI. ONI stimulează
                    gândirea logică și performanța în domeniul programării competitive.
                </p>
                <p className="olimpiadeText1">ONTI - Olimpiada Națională de Tehnologia Informației - <a href="/olimpiade/Regulament_ONTI_2025.pdf" className="fixColor" target="blank">Regulament & Programă</a></p>
                <p className="olimpiadeText2">
                    ONTI este o competiție axată pe competențele digitale și utilizarea practică a aplicațiilor informatice.
                    Elevii concurează la două secțiuni principale: TIC (Tehnologia Informației și a Comunicațiilor), unde sunt
                    testate cunoștințe în lucrul cu aplicații precum Word, Excel, baze de date etc., și Programare C#, pentru
                    cei care doresc să abordeze probleme de cod mai simple decât cele din ONI. OTI pune accentul pe utilizarea
                    practică a tehnologiei în viața reală și profesională.
                </p>
                <p className="olimpiadeText1">OIA - Olimpiada de Inteligență Artificială - <a href="/olimpiade/Regulament_OIA_2025.pdf" className="fixColor" target="blank">Regulament & Programă</a></p>
                <p className="olimpiadeText2">
                    OIA este o competiție relativ nouă, care își propune să încurajeze elevii să exploreze domeniul emergent al
                    inteligenței artificiale. Participanții lucrează cu concepte precum învățarea automată, rețele neuronale sau
                    procesarea limbajului natural, demonstrând atât creativitate, cât și înțelegere tehnică. ONIA încurajează
                    gândirea inovatoare și familiarizarea timpurie cu noile tehnologii ce modelează viitorul.
                </p>
                <p className="olimpiadeText1">OSC - Olimpiada de Securitate Cibernetică - <a href="/olimpiade/Regulament_OSC_2025.pdf" className="fixColor" target="blank">Regulament & Programă</a></p>
                <p className="olimpiadeText2">
                    OSC este o competiție ce testează cunoștințele și abilitățile elevilor în domeniul securității informatice.
                    Concursul abordează teme precum criptografia, analiza vulnerabilităților, forensics sau protecția rețelelor.
                    Participanții trebuie să dovedească atât cunoștințe teoretice, cât și capacitatea de a rezolva scenarii
                    practice, într-un domeniu esențial pentru societatea digitală actuală.
                </p>
            </Row>
        </Container>
    )
}